import { render, staticRenderFns } from "./TopSessionButton.vue?vue&type=template&id=05d1435e&scoped=true"
import script from "./TopSessionButton.vue?vue&type=script&lang=js"
export * from "./TopSessionButton.vue?vue&type=script&lang=js"
import style0 from "./TopSessionButton.vue?vue&type=style&index=0&id=05d1435e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d1435e",
  null
  
)

export default component.exports